import ArticleLink from './ArticleLink';

export { default as ArticleLinkTheme } from './ArticleLink.styled';
export default ArticleLink;
